/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIRoleSubRole } from './APIRoleSubRole';
import {
    APIRoleSubRoleFromJSON,
    APIRoleSubRoleFromJSONTyped,
    APIRoleSubRoleToJSON,
} from './APIRoleSubRole';

/**
 * 
 * @export
 * @interface APIRoleSearchResult
 */
export interface APIRoleSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIRoleSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIRoleSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIRoleSearchResult
     */
    self: string;
    /**
     * 
     * @type {string}
     * @memberof APIRoleSearchResult
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIRoleSearchResult
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIRoleSearchResult
     */
    isGuestUserRole: boolean;
    /**
     * 
     * @type {Array<APIRoleSubRole>}
     * @memberof APIRoleSearchResult
     */
    subRoles?: Array<APIRoleSubRole>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIRoleSearchResult
     */
    subRoleIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIRoleSearchResult
     */
    subRoleNames: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIRoleSearchResult
     */
    rootAccountId?: string | null;
}

/**
 * Check if a given object implements the APIRoleSearchResult interface.
 */
export function instanceOfAPIRoleSearchResult(value: object): value is APIRoleSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isGuestUserRole' in value) || value['isGuestUserRole'] === undefined) return false;
    if (!('subRoleIds' in value) || value['subRoleIds'] === undefined) return false;
    if (!('subRoleNames' in value) || value['subRoleNames'] === undefined) return false;
    return true;
}

export function APIRoleSearchResultFromJSON(json: any): APIRoleSearchResult {
    return APIRoleSearchResultFromJSONTyped(json, false);
}

export function APIRoleSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRoleSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'self': json['self'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'isGuestUserRole': json['is_guest_user_role'],
        'subRoles': json['sub_roles'] == null ? undefined : ((json['sub_roles'] as Array<any>).map(APIRoleSubRoleFromJSON)),
        'subRoleIds': json['sub_role_ids'],
        'subRoleNames': json['sub_role_names'],
        'rootAccountId': json['root_account_id'] == null ? undefined : json['root_account_id'],
    };
}

export function APIRoleSearchResultToJSON(value?: APIRoleSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'self': value['self'],
        'name': value['name'],
        'description': value['description'],
        'is_guest_user_role': value['isGuestUserRole'],
        'sub_roles': value['subRoles'] == null ? undefined : ((value['subRoles'] as Array<any>).map(APIRoleSubRoleToJSON)),
        'sub_role_ids': value['subRoleIds'],
        'sub_role_names': value['subRoleNames'],
        'root_account_id': value['rootAccountId'],
    };
}

